import pic from '@/utils/pic'
const {
  icon1,
  icon2,
  icon3,
  langzh,
  langen,langno,
  langtw,
  langjp,
  langxby,
  langit,
  langdy,
  langfy,
  langhy,
  langty,
  langyn,
  zhsz,
  jtrz,
  sfrz,
  iconchecked,
  iconcheck,
  icon1_01,
  icon1_02,
  icon1_03,
  icon1_04,
  banner01,
  banner02,
  banner03
} = pic

export default {
  "currency": {
    "bb": "Kryptovaluta handel",
    "bba": "Kryptovaluta konto",
    "hy": "Kontraktshandel",
    "jg": "Leveringskontrakt",
    "hya": "Kontraktskonto"
  },
  "index": {
    "h24": "24T volum",
    "header_title": ["For digital eiendomshandel velg " + window.GLOBAL.LANG_TITLE.zh],
    "header_small_title": "En komplett one-stop blockchain digital eiendomshandel",
    "header_msg": "Sikker - Stabil - Pålitelig",
    "register_title": "Registrer en " + window.GLOBAL.LANG_TITLE.zh + " global konto for å starte handelsreisen",
    "register_pl": "Vennligst skriv inn e-posten din eller telefonnummeret",
    "register": "Registrer",
    "featureTitleWhy": "Hvorfor velge oss",
    "featureTitle": "Sikker · Stabil · Pålitelig",
    "featureMsg": "",
    "featureList": [{
        "icon": "icon1",
        "title": "Sikker lommebokteknologi",
        "msg": ["Kald og varm lommebokteknologi utviklet av verdensledende sikkerhetsteam, ingen tap av midler har skjedd.", ""]
      },
      {
        "icon": "icon2",
        "title": "Rik på kryptovaluta tjenester",
        "msg": ["Støtter spot- og flere derivathandler, er din personlige assistent for å komme inn i kryptovalutaens verden.", ""]
      },
      {
        "icon": "icon3",
        "title": "Kunder over hele verden",
        "msg": ["Tilbyr omfattende tjenester for kryptovaluta til brukere i over 130 land eller regioner.", ""]
      }
    ],
    "bannerList": [{
        "icon": "banner01",
        "title": "Forpliktet til å tilby bransjens ledende sikkerhet og stabilitet",
        "msg": ["Smarte kontrakter sikrer investorenes eiendeler", "Handelsytelse er ekte", "24t servicegaranti"]
      },
      {
        "icon": "banner02",
        "title": "Jeg vil kjøpe og selge umiddelbart med enkle operasjoner",
        "msg": ["Enkel handelsgrensesnitt", "Reflekteres umiddelbart på din konto", "De fleste kryptovalutaer kan handles"]
      },
      {
        "icon": "banner03",
        "title": "Jeg vil aktivt tjene profitt gjennom kontrakthandel",
        "msg": ["Åpne konto samtidig", "Strategiske investeringer i futures trading", "365 dager i året, 24 timer om dagen kan handles, selv i helgene"]
      }
    ],
    "featureList2": [
      {
        "icon": "icon1_01",
        "title": "Transparent og åpen",
        "msg": ["Bruker egenskapene til blockchain og smarte kontrakter for å registrere handelsytelse på en ekte måte, og bruker smarte kontrakter for å sikre investorenes eiendeler.", ""]
      },
      {
        "icon": "icon1_02",
        "title": "Smart investering",
        "msg": ["Fleksible strategier levert av topp kvantitative handelseksperter, fritt valg.", ""]
      },
      {
        "icon": "icon1_03",
        "title": "Risiko klassifisering",
        "msg": ["Designet for å tilby mangfoldige investeringsprodukter basert på forskjellige risikopreferanser og kapitalforvaltningspreferanser, effektivt fjerne investeringsbarrierer.", ""]
      },
      {
        "icon": "icon1_04",
        "title": "Mangfold av produkter",
        "msg": ["Tilbyr plattformmekanismer for ulike brukeres investeringsbehov og fleksibilitet, kontinuerlig produsere innovative finansielle tjenester som overgår markedet.", ""]
      }
    ],
    "featureTitle2": "Handel på flere plattformer når som helst, hvor som helst",
    "featureMsg2": "Dekker flere plattformer som iOS og Android, støtter alle forretningsfunksjoner",
    "tab": ["Hovedvaluta", "24T endringsliste"],
    "thead": ["Navn", "Siste pris", "Dagens høyeste pris", "Dagens laveste", "Endringsliste", "24T handelsvolum", "Operasjon"],
    "more": "Se mer >",
    "btn": "Handel",
    "dealsTitle": "One-stop handelstjenester",
    "dealsTab": [
      {
        "title": "Kryptovaluta handel",
        "content": "Kryptovaluta handel er bytte mellom digitale eiendeler, med USDT som valutaenhet for å kjøpe andre valutaer." + window.GLOBAL.LANG_TITLE.zh + " Kryptovaluta handel støtter sanntidshandel av Bitcoin, Ethereum, Litecoin og andre digitale eiendeler.",
        "src": "/static/image/deals-1.jpg",
        "path": ""
      },
      {
        "title": "Kontraktshandel",
        "content": "En finansiell derivat av kryptovaluta, som ikke bare støtter valg mellom å kjøpe eller selge kontrakter for å tjene inntekter, men også er enkel å bruke, uten utløp." + window.GLOBAL.LANG_TITLE.zh + " Kontrakter har et avansert risikostyringssystem med en maksimal giring på 100 ganger.",
        "src": "/static/image/deals-2.jpg",
        "path": ""
      }
    ]
  },
  "market": {
    "tab": ["Favoritter", "Kontrakt", "Kryptovaluta"],
    "thead": ["Valuta", "Siste pris", "24T endring", "24T laveste", "24T høyeste", "24T handelsvolum", "Operasjon"],
    "nodata": "Ingen data tilgjengelig"
  },
  "footer": {
    "p": "©Copyright " + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + ". Alle rettigheter reservert.",
    "dd": [{
        "dt": "Om oss",
        "dd": [
          {
            "title": "Firmaoversikt",
            "id": 1
          },
          {
            "title": "Hjelpesenter",
            "type": "help"
          }]
      },
      {
        "dt": "Brukerstøtte",
        "dd": [{
            "title": "Brukeravtale",
            "id": 3
          },
          {
            "title": "Personvernerklæring",
            "id": 5
          }]
      },
      {
        "dt": "Kontakt oss",
        "icon": true
      }]
  },
  "nav": {
    "btn": ["Logg inn", "Registrer", "Kapitalforvaltning", "Last ned APP"],
    "nav": [{
        "title": "Hjem",
        "path": "/index",
        "name": "index"
      },
      {
        "title": "Marked",
        "path": "/market",
        "name": "market"
      },
      {
        "title": "Kontraktshandel",
        "path": "/deal_jg",
        "name": "deal_jg"
      },
      {
        "title": "Posisjonsrabatt",
        "path": "/profit_index",
        "name": "profit_index"
      }],
    "nav2": [{
        "title": "Mine eiendeler",
        "path": "/asset"
      }
    ],
    "menus": [{
        "icon": langzh,
        "title": "Brukersenter",
        "path": "/setting"
      },
      {
        "icon": langen,
        "title": "Logg ut"
      }
    ],
    "lang": [{
        "icon": langen,
        "lang": "Engelsk",
        "key": "en"
      },
      {
        icon: langno,
        lang: "Norsk",
        key: 'no'
      },
      {
        "icon": langit,
        "lang": "Italiensk",
        "key": "it"
      },
      {
        "icon": langxby,
        "lang": "Spansk",
        "key": "es"
      },
      {
        "icon": langfy,
        "lang": "Fransk",
        "key": "fr"
      },
      {
        "icon": langdy,
        "lang": "Tysk",
        "key": "de"
      },
      {
        "icon": langjp,
        "lang": "Japansk",
        "key": "jp"
      },
      {
        "icon": langhy,
        "lang": "Koreansk",
        "key": "kr"
      },
      {
        "icon": langty,
        "lang": "Thai",
        "key": "th"
      },
      {
        "icon": langyn,
        "lang": "Vietnamesisk",
        "key": "vn"
      },
      {
        "icon": langzh,
        "lang": "Forenklet kinesisk",
        "key": "zh"
      },
      {
        "icon": langtw,
        "lang": "Tradisjonelt kinesisk",
        "key": "tw"
      }
    ]
  },
  "download": {
    "xz": "Last ned"
  },

  "login": {
    "login": "Velkommen til innlogging",
    "msg": "Vennligst skriv inn din registrerte konto",
    "list": ["Mobil/epost", "Passord", "Glemt passord?", "Logg inn", "Har ikke konto? Registrer deg nå"],
    "message": "Konto eller passord kan ikke være tomt"
  },
  "register": {
    "dl": ["Mobilregistrering", "Epostregistrering"],
    "title": "Registrer konto",
    "country": "Nasjonalitet",
    "country_info": "Nasjonalitetsinformasjonen kan ikke endres etter registrering, vennligst velg riktig.",
    "account": "Konto",
    "code_text": "Vennligst skriv inn bekreftelseskoden",
    "code_btn": "Få bekreftelseskode",
    "code_unit": "s",
    "code_no_data": "Bekreftelseskoden kan ikke være tom",
    "password_text": "Vennligst skriv inn passord",
    "password_again_text": "Vennligst skriv inn passordet på nytt",
    "pid_text": "Invitasjonskode",
    "pid_pl": "Valgfritt",
    "invitation_code_no_data": "Invitasjonskode er påkrevd",
    "xy": "Brukeravtale",
    "xy_no_checked": "Vennligst velg avtalen",
    "agree": "Jeg har lest og godtar",
    "register_btn": "Registrer",
    "bz": [
      "Nasjonalitetsinformasjonen kan ikke endres etter registrering, vennligst velg riktig.",
      "Bekreftelsesepost kan bli feilaktig vurdert som søppelpost, vennligst sjekk.",
      "Vennligst oppbevar din " + window.GLOBAL.LANG_TITLE.zh + " konto og innloggingspassord på en trygg måte.",
      "Ikke bruk det samme innloggingspassordet som andre nettsteder."
    ],
    "account_no_data": "Konto kan ikke være tom",
    "code_no_equality": "Bekreftelseskoden er ikke lik",
    "password_no_data": "Passord kan ikke være tomt",
    "password_no_equality": "De to passordene er ikke like"
  },
  "bindmpwd": {
    "title": "Sett passord",
    "account": "Konto",
    "code_text": "Vennligst skriv inn bekreftelseskoden",
    "code_btn": "Få bekreftelseskode",
    "code_unit": "s",
    "password_text": "Vennligst skriv inn passord",
    "password_again_text": "Vennligst skriv inn passordet på nytt",
    "code_no_data": "Bekreftelseskoden kan ikke være tom",
    "code_no_equality": "Bekreftelseskoden er ikke lik",
    "password_no_data": "Passord kan ikke være tomt",
    "password_no_equality": "De to passordene er ikke like",
    "bindmpwd_btn": "Bekreft",
    "phone_no_data": "Mobilnummer kan ikke være tomt",
    "password_login_text": "Vennligst skriv inn innloggingspassord",
    "password_trade_text": "Passordlengde 6 siffer",
    "password_again_tarde_text": "Passordlengde 6 siffer"
  },

  "forgetpwd": {
    "title": ["Endre passord", "Glemt passord"],
    "account": "Konto",
    "code_text": "Vennligst skriv inn bekreftelseskoden",
    "code_btn": "Få bekreftelseskode",
    "code_unit": "s",
    "password_text": "Vennligst skriv inn passord",
    "password_again_text": "Vennligst skriv inn passordet på nytt",
    "phone_no_data": "Mobilnummer kan ikke være tomt",
    "account_no_data": "Konto kan ikke være tom",
    "code_no_data": "Bekreftelseskoden kan ikke være tom",
    "code_no_equality": "Bekreftelseskoden er ikke lik",
    "password_no_data": "Passord kan ikke være tomt",
    "password_no_equality": "De to passordene er ikke like",
    "forgetpwd_btn": "Bekreft"
  },

  "bindphone": {
    "title": "Bind mobilnummer",
    "phone_text": "Mobilnummer"
  },
  "person": {
    "more": "Last inn mer",
    "no_more": "Ingen flere data",
    "index_center": "Brukersenter",
    "index_menus": [
      {
        "icon": "zhsz",
        "title": "Kontoadministrasjon",
        "path": "/setting"
      },
      {
        "icon": "sfrz",
        "title": "Identitetsverifisering",
        "path": "/sfyz"
      },
      {
        "icon": "sfrz",
        "title": "Grunnleggende verifisering",
        "path": "/smauth"
      },
      {
        "icon": "jtrz",
        "title": "Avansert verifisering",
        "path": "/seniorauth"
      },
      {
        "icon": "jtrz",
        "title": "Adresseverifisering",
        "path": "/dzrz"
      },
      {
        "icon": "jtrz",
        "title": "Rask kjøp av kryptovaluta",
        "path": "/kjmbSelect"
      },
      {
        "icon": "jtrz",
        "title": "Kredittpoeng",
        "path": "/credit"
      },
      {
        "icon": "jtrz",
        "title": "Kontoopptegnelser",
        "path": "/deallog"
      },
      {
        "icon": "jtrz",
        "title": "Innskuddsopptegnelser",
        "path": "/cbjl"
      },
      {
        "icon": "jtrz",
        "title": "Uttaksopptegnelser",
        "path": "/tbjl"
      }
    ],
    "cbtb": "Innskudd og uttak",
    "jymx": "Handelsdetaljer",
    "xyf": {
      "title": "Kredittpoeng",
      "pgsj": "Vurderingstid"
    },
    "smrz": {
      "title": "Identitetsverifisering",
      "sure_title": "Du har bestått identitetsverifisering",
      "zj_type": "Dokumenttype",
      "zj_info": [
        "1. Verifiseringsinformasjon kan ikke endres etter bekreftelse, vennligst fyll ut korrekt.",
        "2. Verifisert identitetsinformasjon kan ikke verifiseres på nytt."
      ],
      "zj_name": "Navn",
      "zj_num": "Dokumentnummer",
      "zj_btn": "Bekreft",
      "zj_rebtn": "Verifiser på nytt",
      "zj_sebtn": "Avansert verifisering",
      "zj_type_array": [{
          "name": "Identitetskort",
          "type": "idcard"
      }],
      idCardArr: [{
        "id": 1,
        "name": "Identitetskort"
      },
      {
        "id": 2,
        "name": "Pass"
      },
      {
        "id": 3,
        "name": "Førerkort"
      },
      {
        "id": 4,
        "name": "Oppholdstillatelse"
      },
      {
        "id": 5,
        "name": "Annet"
      },],
      "zj_data": {
        "city": "Nasjonalitet kan ikke være tom",
        "type": "Dokumenttype kan ikke være tom",
        "name": "Navn kan ikke være tomt",
        "zj_num": "Dokumentnummer kan ikke være tomt"
      },
      "zsxm": "Ekte navn",
      "qsrzsxm": "Vennligst skriv inn ekte navn",
      "zjlx": "Dokumenttype",
      "qxzzjlx": "Vennligst velg dokumenttype",
      "sfz": "Identitetskort",
      "zjhm": "Dokumentnummer",
      "qsrzjhm": "Vennligst skriv inn dokumentnummer",
      "sczjz": "Last opp dokumentfoto",
      "zjzm": "Last opp dokumentets forside",
      "zjfm": "Last opp dokumentets bakside",
      "qsczjzm": "Vennligst last opp dokumentets forside",
      "qsczjfm": "Vennligst last opp dokumentets bakside",
      "scqmz": "Last opp dokument med personlig signatur",
      "qscscqmz": "Vennligst last opp dokument med personlig signatur",
      "zj": [{
          "id": 1,
          "title": "Identitetskort"
        },
        {
          "id": 2,
          "title": "Pass"
        },
        {
          "id": 3,
          "title": "Annet"
        }
      ],
      "tj": "Send inn",
      "shz": "Under vurdering",
      "shtg": "Godkjent",
      },
      "gjrz": {
        "title": "Avansert verifisering",
        "zj_info": [
          "1. Støtter bilder i JPG, JPEG eller PNG format mindre enn 8M.",
          "2. Dokumentfoto må være klart, uten endringer eller skjul, må vise ansikt, dokumentnummer og navn.",
          "3. Foto skal være uten hat, anbefales uten sminke, ansiktet til dokumentinnehaveren må være klart synlig, med armene fullt synlige."
        ],
        "zj_img": [
          "/static/image/User_Center_Front_view.png",
          "/static/image/User_Center_Back_Shot.png",
          "/static/image/User_Center_Full_picture.png"
        ]
      },
      "zhgl": {
        "title": "Sikkerhetsinnstillinger",
        "bind": [
          {
            "bind_title": "Tilbakestill passord",
            "bind_name": "Epost"
          },
          {
            "bind_title": "Sett handelspassord",
            "bind_name": "Epost"
          }
        ]
      },
      "wdtg": {
        "own_code": "Egen invitasjonskode",
        "own_code_url": "Egen invitasjonslenke",
        "own_push_title": "Min promotering",
        "own_push_content": [
          "Total inntekt fra invitasjoner (verdi)",
          "Antall inviterte",
          "Personer"
        ],
        "own_push_content_profit": [
          "Inntekt fra første nivå invitasjoner",
          "Inntekt fra andre nivå invitasjoner",
          "Inntekt fra tredje nivå invitasjoner",
          "Inntekt fra fjerde nivå invitasjoner"
        ],
        "own_push_content_num": [
          "Antall første nivå invitasjoner",
          "Antall andre nivå invitasjoner",
          "Antall tredje nivå invitasjoner",
          "Antall fjerde nivå invitasjoner"
        ],
        "own_push_profit_title": [
          "ID",
          "Inntekt",
          "Merknadsinformasjon",
          "Legg til tid"
        ],
        "own_push_num_title": [
          "ID",
          "Navn",
          "Telefon",
          "Legg til tid"
        ]
      },
      "jyzt_td": ["Tid", "Detaljer", "Beløp"],
      "cbjl_td": ["Tid", "Valuta", "Mengde", "Status"],
      "sfrz_txt": [
        "Identitetsverifisering",
        "Du har sendt inn for vurdering, vennligst vent på resultatet",
        "Du har bestått avansert verifisering",
        "Forside av identitetskort",
        "Bakside av identitetskort",
        "Verifisering",
        "Verifisering feilet, vennligst verifiser på nytt"
      ],
      "zhsz_txt": [
        "Din kontos sikkerhetsnivå: #",
        "Din kontos sikkerhetsnivå: #, fullfør flere opplysninger for å sikre kontoen."
      ],
      "zhsz_m": "Sterk",
      "zhsz_n": "Svak",
      "zhsz_p": "Usikker",
      "zhsz_detailList": [
        {
          "icon": "/static/image/User_Center-password.png",
          "title": "Innloggingspassord",
          "value": "Internettkontoer har risiko for å bli stjålet, det anbefales å endre passord regelmessig for å beskytte kontoen.",
          "value2": "",
          "btn": "Endre",
          "bind_email": "Vennligst bind epost eller mobil først",
          "path": "/forgetpwd?type=changepwd"
        },
        {
          "icon": "/static/image/User_Center-password.png",
          "title": "Handelspassord",
          "value": "Sett passord",
          "btn": "Gå til innstilling",
          "path": "/bindmpwd"
        }
      ],
      "sksz_txt": ["Innstillinger for mottak", "Lagre"],
      "sksz_list": [
        {
          "label": "Brukernavn:",
          "pl": "Vennligst skriv inn brukernavn",
          "key": "name"
        },
        {
          "label": "Navn på bank:",
          "pl": "Vennligst skriv inn navn på bank",
          "key": "bank_name"
        },
        {
          "label": "Bankkontonummer:",
          "pl": "Vennligst skriv inn bankkontonummer",
          "key": "bank_number"
        },
        {
          "label": "Alipay-konto:",
          "pl": "Vennligst skriv inn Alipay-konto",
          "key": "alipay_account"
        },
        {
          "label": "WeChat-nickname:",
          "pl": "Vennligst skriv inn WeChat-nickname",
          "key": "weixin_nickname"
        },
        {
          "label": "WeChat-konto:",
          "pl": "Vennligst skriv inn WeChat-konto",
          "key": "weixin_account"
        }
      ]
  },
  "pasination": {
    "first": "Hjem",
    "prev": "Forrige side",
    "next": "Neste side",
    "last": "Siste side",
    "no_data": "Ingen data tilgjengelig"
  },
  "asset": {
    "title": "Mine eiendeler",
    "zjhz": "Overføring av midler",
    "cb": "Innskudd",
    "gz": "USDT vurdering",
    "atnv": [],
    "zh_title": "Total eiendelverdi:",
    "index_title": "Eiendeler",
    "address_title": "Valuta",
    "address_txt": ["Vennligst velg", "Uttaksadresse", "Vennligst skriv inn innhold", "Merknad", "Adressen liste"],
    "address_btn": ["Legg til", "Lagre", "Slett", "Rediger"],
    "address_td": ["Valuta", "Uttaksadresse", "Merknad", "Handling"],
    "currency_td": ["Valuta", "Tilgjengelig", "Frosset", "Verdi"],
    "table_title": "Totale eiendeler:",
    "table_address_title": "Administrasjon av uttaksadresser",
    "table_td": ["Valuta", "Tilgjengelig", "Frosset", "Verdi", "Handling"],
    "table_btn": ["Innskudd", "Uttak", "Opptegnelser", "Overføring"],
    "money_text": [
      "Uttaksadresse",
      "Vennligst velg",
      "Mengde",
      "Tilgjengelig:",
      "Gebyr",
      "Beløp som kommer frem",
      "Handelspassord",
      "Merkelapp (Memo)",
      "Minste uttak"
    ],
    "money_btn": "Uttak",
    "xzbz": "Velg valuta",
    "money_msg": [
      "Vennlig påminnelse",
      "1. Uttakstid er Hongkong-tid 12:00-24:00, kan sende inn 2 uttaksforespørsel daglig (minste uttak 100u, maksimalt uttak 200000u);",
      "2. For tiden støtter uttak kun USDT-valuta, velg ERC20 for lommeboktype;",
      "3. Etter å ha sendt inn uttaksforespørselen, vil midlene være i frosset status fordi uttaket er i prosess, midlene forvaltes midlertidig av systemet og kan ikke fritt disponeres av deg. Dette betyr ikke at du har tapt disse eiendelene eller at det har oppstått unormale forhold. Vennligst vent tålmodig på godkjenning;",
      "4. Etter å ha sendt inn uttaksforespørselen, vil leveringstiden være basert på blokkbekreftelsestidspunktet. Hvis midlene ikke er mottatt etter forventet uttakstid, vennligst kontakt kundeservice for forespørsel;",
      "5. For å forhindre kontantuttak, må du ha brukt totalt 90% av forbruket for å kunne initiere uttak."
    ],
    "recharge_title": "Innskuddsadresse",
    "recharge_btn": ["Kopier", "QR-kode", "Innskudd"],
    "recharge_text": [
      "Mengde",
      "Vennlig påminnelse",
      "Vennligst ikke innskudd noen ikke-USDT eiendeler til ovennevnte adresse, ellers vil eiendelene ikke kunne gjenopprettes.",
      "USDT-innskudd støtter kun metoden 'simple send', innskudd ved bruk av andre metoder ('send all') kan midlertidig ikke krediteres, vi ber om forståelse.",
      "Bevis",
      "Beskrivelse av bevis (valgfritt)",
      "Kjedenavn"
    ],
    "record_title": "Finansielle opptegnelser",
    "record_td": ["Mengde", "Opptegnelse", "Tid"],
    "transfer_title": "Overføring",
    "transfer_btn": ["Alle", "Overfør"],
    "transfer_text": ["Fra", "Til", "Vennligst skriv inn overføringsmengde", "Tilgjengelig:"],
    "bq": "Merkelapp (Memo)",
    "qsrbq": "Vennligst skriv inn merkelapp",
    "yhktx": "Bankkortuttak",
    "yhmc": "Banknavn",
    "qsryhmc": "Vennligst skriv inn banknavn",
    "yhzh": "Bankkonto",
    "qsryhzh": "Vennligst skriv inn bankkonto",
    "gjhkdm": "Internasjonal overføringskode",
    "qsrgjhkdm": "Vennligst skriv inn internasjonal overføringskode",
    "yhdz": "Bankadresse",
    "qsryhdz": "Vennligst skriv inn bankadresse",
    "skrxm": "Mottakers navn",
    "qsrskrxm": "Vennligst skriv inn mottakers navn",
    "skrdh": "Mottakers telefon",
    "qsrskrdh": "Vennligst skriv inn mottakers telefon",
    "skrdz": "Mottakers adresse",
    "qsrskrdz": "Vennligst skriv inn mottakers adresse"
  },
  "text": {
    "btn": "Tilbake",
    "login": "Vennligst logg inn først"
  },
  "deal": {
    "chooseType": "Oppdragstype",
    "choose": "Vennligst velg",
    "balance": "Saldo:",
    "account": ["Konto", "Tilgjengelig", "/Frosset", "Overføring"],
    "dir": ["Kjøp", "Selg"],
    "dir2": ["Kan kjøpes", "Kan selges"],
    "cs": "Favoritter",
    "sxf": "Gebyr",
    "jye": "Handelsbeløp",
    "sc_list": ["Marked", "Navn", "Endring"],
    "sc_h": ["Nåværende pris", "24H laveste pris", "24H høyeste pris", "24H handelsvolum"],
    "td_lt": ["Valuta", "Siste pris", "Endring"],
    "k_line_txt": ["≈", "", "Endring", "Høyeste pris", "Laveste pris", "24H volum"],
    "tabListLTitle": ["Nåværende oppdrag", "Historiske oppdrag"],
    "tabListLEntrust": ["Kjøp", "Selg"],
    "tabListRTitle": ["Limit handel", "Markedspris handel"],
    "table_btn": ["Avbryt ordre"],
    "index_td_l": ["Tid", "Handelsobjekt", "Mengde", "Pris", "Handling"],
    "index_td_r": ["Siste pris", "Retning", "Pris", "Mengde"],
    "index_td_r2": ["Siste handel", "Tid", "Pris", "Handelsvolum"],
    "table_txt": ["Fullført", "Avbrutt"],
    "db_1_txt": ["Tilgjengelig", "Kjøpspris", "Salgspris", "Kjøpsmengde", "Salgsmengde", "Handelsbeløp", "Kjøp til beste markedspris", "Selg til beste markedspris", "Kjøpshånd", "Salgsandel"],
    "db_2_txt": ["Pris", "Giring", "Vennligst velg", "Håndter", "En hånd = ", "Hånd", "Kontraktsverdi", "Margin", "Kjøp til beste markedspris", "Selg til beste markedspris"],
    "pathList": ["Kontraktsopptegnelser", "Handelsopptegnelser"],
    "db_btn": ["Kjøp (Long)", "Selg (Short)"],
    "tabListLTitle2": ["Nåværende oppdrag"],
    "lt_btn": ["Lukk posisjon med ett klikk", "Sett take profit og stop loss pris", "Lukk posisjon", "Send inn umiddelbart", "Tilbake"],
    "lt_txt": ["Risikoandel:", "Total gevinst/tap:"],
    "lt_td": ["Type", "Giring", "Inngangspris", "Nåværende pris", "Margin", "Take profit pris", "Stop loss pris", "Inngangstid", "Håndter", "Gevinst/tap", "Handling"],
    "lt_dl": ["Sett take profit og stop loss pris", "Take profit pris", "Stop loss pris"],
    "lt_0_btn": ["Avbryt ordre"],
    "lt_0_td": ["Kontaktinformasjon", "Valuta", "Mengde", "Nåværende pris", "Gebyr", "Handling"],
    "lt_1_btn": ["Lukk posisjon"],
    "lt_1_txt": ["Lukking pågår"],
    "lt_1_td": ["Type", "Inngangspris", "Nåværende pris", "Margin", "Take profit pris", "Stop loss pris", "Inngangstid", "Gebyr", "Gevinst/tap", "Handling"],
    "node_data": "Ingen data tilgjengelig",
    "lt_3_txt": ["Posisjon lukket", "Likvidert"],
    "lt_3_td": ["Type", "Håndter", "Inngangspris", "Lukkingspris", "Take profit pris", "Stop loss pris", "Margin", "Tilgjengelig margin", "Inngangstid", "Lukketid", "Gebyr", "Gevinst/tap", "Handling"],
    "lt_4_txt": ["Ordre avbrutt"],
    "cm": ["Utgivelsestid", "Total utgivelse", "Total sirkulasjon", "Total pris", "Offisiell nettside", "Whitepaper", "Introduksjon"],
    "qsrsl": "Vennligst skriv inn mengde",
    "qsrss": "Vennligst skriv inn håndter",
  },
  "notice": {
    "notice_title": "Kunskapssenter"
  },
  "bzhl": {
    "title": "Rabatt på posisjoner",
    "ttzbt": "Tjen penger hver dag",
    "wdtg": "Min forvaltning",
    "zztgdzj": "Midler som forvaltes",
    "yjjrsy": "Estimert daglig avkastning",
    "ljsy": "Total avkastning",
    "tgzdd": "Ordrer under forvaltning",
    "tgdd": "Forvaltningsordrer",
    "t1": "Lavrisiko stabil investering, kan innløses når som helst",
    "t2": "Din lille hjelper for håndtering av overskudd",
    "cljxcp": "Produktperiode",
    "dbxe": "Maksimumsbeløp per transaksjon",
    "rsyl": "Avkastningsrate (%)",
    "rsyl2": "Daglig avkastningsrate:",
    "zq": "Periode",
    "qmr": "Gå til kjøp",
    "ckgd": "Se mer",
    "cpgk": "Produktoversikt",
    "pxsj": "Utbetalingsdato",
    "tgzj": "Forvaltede midler",
    "tqsh": "Innløsning",
    "cpld": "Produktegenskaper",
    "cpgz": "Produktregler",
    "cont": "Arbitrage er å overføre USDT til plattformen, der plattformens fagteam utfører arbitrage-rettigheter. Deltakere kan motta en andel av plattformens arbitrage-inntekter i løpet av forvaltningstiden, med mulighet for innskudd og uttak, sikkert og praktisk.",
    "zj": "100% midler",
    "aqbz": "Sikkerhetsgaranti",
    "jjrsy": "Helligdagsavkastning",
    "bjd": "Uavbrutt",
    "cgcrh": "Etter vellykket innskudd",
    "dtqx": "Renter begynner samme dag",
    "ljzr": "Overfør umiddelbart",
    "xqglgj": "Verktøy for håndtering av overskudd",
    "ddh": "Ordrenummer",
    "tgje": "Forvaltningsbeløp",
    "tgsj": "Periode dager",
    "yhl": "Allerede tjent / gjenværende dager",
    "xdsj": "Bestillingstid",
    "zt": "Status",
    "fh": "Tilbake",
    "qrnhsy": "Årlig avkastning på syv dager",
    "ygy": "1 måned",
    "bn": "6 måneder",
    "yn": "1 år",
    "yuan": "Yuan",
    "tzfx": "Investeringsrisiko",
    "shsc": "Innløsningsvarighet",
    "di": "Lav",
    "yggzr": "En arbeidsdag",
    "msgsxf": "Ingen gebyr for innkjøp",
    "mr": "Daglig",
    "dqfh": "Tilbakebetaling ved forfall",
    "ljgm": "Kjøp umiddelbart",
    "tgz": "Under forvaltning",
    "sh": "Innløsning",
    "ywc": "Fullført",
    "ysh": "Innløst",
    "all": "Alle",
    "xzbzts": "Enkelt, sikkert. Kan velge flere valutaer for utbetaling.",
    "qtbz": "Andre valutaer"
  },
  "pay": {
    "qsrjymm": "Vennligst skriv inn 6-sifret handelspassord",
    "tbmmts": "Vennligst gå til brukersenteret for å sette handelspassord"
  },
  "tips": {
    "qxztbdz": "Vennligst skriv inn uttaksadresse",
    "qsrtbsl": "Vennligst skriv inn uttaksbeløp"
  },
  "statusText": ["Feil", "Venter på behandling", "Suksess"],
  "dzrz": {
    "title": "Adresseverifisering",
    "sdddz": "Vann- og strømregning adresse",
    "zdtpsc": "Last opp regning bilde",
    "qsrsdddz": "Du må fylle ut adresseinformasjon og sende inn regning for vann- eller strømregning.",
    "qsczdtp": "Vennligst last opp regning bilde",
    "status": ["Under vurdering", "Godkjent"],
    "qd": "Bekreft"
  },
  "jgcc": {
    "wtgd": "Oppdragsbestilling",
    "cj": "Fullført",
    "jj": "Introduksjon",
    "zc": "I besittelse",
    "lszc": "Historisk beholdning",
    "qblx": "Alle typer",
    "xj": "Nåværende pris",
    "sj": "Tid",
    "fx": "Retning",
    "jg": "Pris",
    "sl": "Mengde",
    "jgsj": "Leveringstid",
    "gmj": "Kjøpspris",
    "jsj": "Oppgjørspris",
    "yk": "Gevinst/tap",
    "xq": "Detaljer",
    "mz": "Kjøp opp",
    "md": "Kjøp ned",
    "dqye": "Nåværende saldo",
    "gb": "Lukk",
    "jxxd": "Fortsett å bestille",
    "qrxd": "Bekreft bestilling",
    "ddqr": "Ordrebekreftelse",
    "sxf": "Gebyr",
    "kyye": "Tilgjengelig saldo",
    "jypz": "Navn",
    "jyfx": "Handelsretning",
    "tzje": "Investeringsbeløp",
    "tzjeTips": "Investeringsbeløp kan ikke være 0",
    "dqsj": "Forfallstid",
    "jssj": "Oppgjørstid",
    "gmsj": "Kjøpstid",
    "sy": "Avkastning",
    "zxje": "Minste mengde",
    "shi": "time",
    "fen": "minutt",
    "miao": "sekund",
    "zdje": "Maksimal mengde",
    "qsrje": "Vennligst skriv inn beløp",
    "zxtzje": "Minste mengde",
    "yebz": "Saldo utilstrekkelig",
    "xq": "Detaljer",
    "ddz": "Venter",
    "jgjl": "Leveringsopptegnelser",
    "bz": "Valuta",
    "cz": "Handling"
  },
  "kjmb": {
    "title": "Rask kjøp av valuta",
    "fzcg": "Kopiering vellykket",
    "ljmb": "Kjøp valuta umiddelbart",
    "lxkf": "Kontakt kundeservice"
  },
  "news": {
    "title": "Mine meldinger",
    "gg": "Kunngjøring",
    "ckxq": "Se detaljer"
  },
  "statusTabs": ["Ordre i behandling", "Handel pågår", "Lukket posisjon", "Avbrutt ordre"],
  "chongzhi": {
    "zy": "Merk",
    "tips2": "1. Lommebok/plattformens kompatibilitet: dvs. støtte for dette nettverket; hvis målplattformen ikke støtter din uttaksnettverk, vil eiendelene ikke kunne gjenopprettes.",
    "tips3": "2. Innskuddsnettverket ditt må være det samme som målplattformen; hvis du velger måladresse på Ethereum-nettverket, men innskuddet er valgt på TRC20 smartkjede, kan du muligens ikke gjenopprette dine digitale eiendeler.",
    "tips4": "3. Før innskudd, sørg for at adressen og beløpet er korrekte.",
    "tips5": "Vennlig påminnelse: På grunn av blokknettverks anonymitet og konfidensialitet, vil du miste tilsvarende eiendeler hvis feil informasjon blir tastet. Vennligst sjekk innskuddsadresse og beløp nøye.",
    "cbxx": "Innskuddsinformasjon",
    "qsrsl": "Vennligst skriv inn innskuddsbeløp",
    "tips2_1": "• Vennligst ikke innskudd noen ikke-eiendeler til ovennevnte adresse, ellers vil eiendelene ikke kunne gjenopprettes.",
    "tips2_2": "• Digitale valutaer kan ikke alltid krediteres umiddelbart, den faktiske krediteringstiden avhenger av blokkbekreftelseshastigheten.",
    "tips2_3": "• Din innskuddsadresse vil ikke endres ofte, og kan brukes til gjentatte innskudd; hvis det er endringer, vil vi prøve å informere deg via nettsideannonse eller e-post."
  },
  "tibi": {
    "tbxx": "Uttaksinformasjon",
    "qsrbq": "Vennligst skriv inn merkelapp",
    "tbTips1": "• For å sikre midlenes sikkerhet, vil uttak bli manuelt vurdert når sikkerhetspolitikken endres, passordet endres; vennligst vent tålmodig på kontakt fra ansatte via telefon eller e-post.",
    "tbTips2": "• Vennligst bekreft at datamaskinen og nettleseren er sikre for å hindre at informasjon blir endret eller lekket.",
    "tbTips3": "• De digitale eiendelene du tar ut er multi-chain eiendeler; uansett hvilken kjede du velger å ta ut fra, vil det bety at den totale mengden av de digitale eiendelene som vises på uttakssiden din reduseres med det tilsvarende uttaksbeløpet."
  },
  "gjlb": "Landliste",
  "qxzgjlb": "Vennligst velg land/region",
  "mbwt": {
    "title": "Sikkerhetsspørsmålinnstillinger",
    "mbwt": "Sikkerhetsspørsmål",
    "problem": [
      {
        "id": 1,
        "title": "Hvem var din beste venn som barn?"
      },
      {
        "id": 2,
        "title": "Hvem er ditt idol?"
      },
      {
        "id": 3,
        "title": "Hvor drømmer du om å dra?"
      }
    ],
    "qtxda": "Vennligst fyll ut svaret",
    "qsrxmm": "Vennligst skriv inn nytt passord",
    "qqrmm": "Vennligst bekreft passord",
    "sydqmmcz": "Bruk nåværende passord for å tilbakestille",
    "zhmm": "Sikkerhetsspørsmål for å tilbakestille passord",
    "ysz": "Allerede satt",
    "tg": "Hopp over",
    "tj": "Send inn",
    "zyts": "Viktig påminnelse:",
    "zytsCont": "Vennligst ikke avslør svarene på sikkerhetsspørsmålene og bekreftelseskoden, og husk sikkerhetsspørsmålene, da dette vil hjelpe deg med å tilbakestille passordet."
  },
  "zc": {
    "zclb": "Eiendel liste",
    "zczh": "Eiendelverdi",
    "yczc": "Skjul eiendeler med verdi 0"
  },
  "indexNew": {
    "t1": "Globalt ledende",
    "t2": "Digital eiendomsserviceplattform",
    "t3": "En komplett one-stop blockchain digital eiendomshandel",
    "t4": "Mobilnummer/e-post",
    "t5": "Registrer deg nå",
    "t6": "Velkommen til kunder fra hele verden gjennom GMO Global",
    "t7": "Oppdag og start deres kryptoreise"
  },
  "newReg": {
    "dl": ["E-post", "Mobil"],
    "cjzh": "Opprett konto",
    "sysjhzyx": "Registrer med mobilnummer/e-post",
    "yhxy": "《Brukeravtale》",
    "yhxy2": "Jeg har lest og godtar 《Brukeravtale》",
    "yxgz": "Den angitte e-posten er ikke i henhold til reglene",
    "dhgz": "Det angitte mobilnummeret har feil format"
  },
  "indexNew2": {
    "t1": "Handle på våre ordrer",
    "t2": "Bruk Bitbank",
    "t3": "Bitbank er en smart designet plattform for Bitcoin og kryptovalutautveksling, veldig enkel, praktisk, sikker og kraftig. Støtter handel på flere web- og smarttelefonplattformer. Handelsdata og diagrammer oppdateres i sanntid, og gir over 60 tekniske analyseverktøy for omfattende markedsprisanalys. Start handel",
    "ksjy": "Start handel",
    "ly": "Fem grunner til å velge Bitbank",
    "item1_t1": "Ledende handelsvolum",
    "item1_t2": "Nr. 1 * Kryptovaluta handelsvolum",
    "item1_t3": "Høy likviditet, komfortabel (behagelig handelsopplevelse) handel. Oppført med 12 kryptovalutaer.",
    "item2_t1": "Høyt vurdert av tredjeparter",
    "item2_t2": "Sikker handelsmiljø",
    "item2_t3": "Bruker offline kalde lommebøker. Holder hackere ute med Multisig. Beskytter eiendelene dine med høyteknologi.",
    "item3_t1": "Brukervennlig og pålitelig applikasjon",
    "item3_t2": "Enkel å bruke applikasjon",
    "item3_t3": "En pålitelig applikasjon med rike funksjoner. Kan handle eksternt for å opprettholde handelsmuligheter.",
    "item4_t1": "Åpen hele døgnet",
    "item4_t2": "Innskudd tilgjengelig",
    "item4_t3": "24 timers innskuddsstøtte, inkludert helligdager!",
    "item5_t1": "Smarttelefon og PC",
    "item5_t2": "Brukervennlig design",
    "item5_t3": "Kan enkelt utføre kvalifisert handel selv med smarttelefon.",
    "aqkk": "Sikker og pålitelig",
    "aqkk2": "Bitcoin-handel hos Bitbank",
    "cjzh": "Opprett en konto"
  },
  "xbsg": {
    "title": "Ny mynt forhåndsbestilling",
    "wdsg": "Mine forhåndsbestillinger",
    "scts": "Låste dager:",
    "sy": "Gjenstående",
    "ljsg": "Bestill nå",
    "ysk": "Utsolgt",
    "xzjdy": "Abonner nå",
    "dy": "Abonner",
    "fxjg": "Utgivelsespris",
    "fxl": "Utgivelsesvolum",
    "ssrq": "Noteringsdato",
    "yxqx": "Gyldighetsperiode",
    "qsrsl": "Vennligst skriv inn mengde",
    "syl": "Gjenstående mengde",
    "sgrq": "Bestillingsdato",
    "sgsl": "Bestillingsmengde",
    "bz": "Valuta",
    "yebz": "USDT-saldo utilstrekkelig",
    "tgsl": "Gjennom mengde",
    "shz": "Under vurdering",
    "wtg": "Ikke godkjent",
    "ytg": "Godkjent"
  },
  "wydb": {
    "title": "Jeg vil låne",
    "db": "Låne",
    "dbz": "Låner",
    "jl": "Opptegnelse",
    "jdzq": "Låneperiode (dager)",
    "qhk": "Gå til tilbakebetaling",
    "ljdb": "Total lån (usdt)",
    "dhkbs": "Antall lån som skal tilbakebetales",
    "jkje": "Lånebeløp (usdt)",
    "qsrje": "Vennligst skriv inn beløp",
    "rll": "Daglig rente",
    "hkfs": "Tilbakebetalingsmetode",
    "dqych": "Tilbakebetaling av hovedstol og renter ved forfall",
    "lx": "Rente",
    "fkjg": "Utbetalingsinstitusjon",
    "tpsc": "Kredittlån (bildeopplasting)",
    "fwxx": "Boliginformasjon",
    "srzm": "Inntektsbevis (ansettelsesforhold)",
    "yhmx": "Bankdetaljer",
    "zjz": "Identitetsbilde",
    "yd": "Jeg har lest og godtar",
    "xy": "Søknad om lån avtale",
    "sqdb": "Klikk for å søke om lån",
    "gb": "Lukk",
    "qd": "Bekreft",
    "ts": "Vennligst merk av for søknad om lån avtale",
    "dbjl": "Låneopptegnelser",
    "hkhth": "Lånekontraktsnummer",
    "wsh": "Ikke vurdert",
    "yfk": "Lånt ut",
    "sqrq": "Søknadsdato",
    "zq": "Periode",
    "dbsl": "Lånemengde",
    "zhke": "Total tilbakebetalingsbeløp",
    "yhkxq": "Detaljer om tilbakebetaling",
    "bqyhk": "Denne perioden skal tilbakebetales (USDT)",
    "hktips": "Vennligst sørg for at saldoen er tilstrekkelig, hvis saldoen er utilstrekkelig, vennligst fyll på før du tilbakebetaler",
    "bj": "Hovedstol",
    "jie": "Låne",
    "ljhk": "Tilbakebetal umiddelbart",
    "qcz": "Gå til innskudd",
    "yebzqxcz": "Saldo utilstrekkelig, vennligst fyll på før tilbakebetaling",
    "znj": "Forsinkelsesgebyr",
    "yqts": "Forsinkelsesdager"
  },
  "hkxq": {
    "dd": "Ordre",
    "fzhkdz": "Kopier tilbakebetalingsadresse",
    "hkxq": "Detaljer om tilbakebetaling",
    "zlx": "Total rente",
    "zhk": "Total tilbakebetaling",
    "hkjg": "Tilbakebetalingsinstitusjon",
    "qschkpz": "Vennligst last opp tilbakebetalingsbevis",
    "hkpz": "Tilbakebetalingsbevis"
  },
  "bbjyNew": {
    "jylx": "Handelstype",
    "jyze": "Total handelsbeløp"
  },
  "bind": {
    "title": "E-postverifisering",
    "ybd": "Allerede bundet",
    "wbd": "Ikke bundet",
    "ts": "For å beskytte kontoen din, anbefales det å binde e-post",
    "qsryxdz": "Vennligst skriv inn e-postadresse"
  },
  "tipsNew": {
    "yjj": "Avvist",
    "shz": "Innløsning pågår"
  },
  "newIndex2": {
    "zxhy": "Siste marked",
    "jypt": "Handelsplattform",
    "dqwz": "Nåværende posisjon",
    "yzm": "Bekreftelseskode",
    "qrmm": "Bekreft passord",
    "djdl": "Klikk for å logge inn",
    "ghdjy": "Bedre handel",
    "ghdsh": "Bedre liv",
    "about": "Verdens mest innovative kryptovaluta handelsenter er her, hvor du kan kjøpe, handle og tjene kryptovaluta, med hundrevis av kryptovalutaer lett tilgjengelig.",
    "index01": "Din port til Bitcoin og andre områder",
    "index02": "Globalt ledende plattform for digitale eiendeler",
    "index03": "Alle typer handel er gratis",
    "index04": "Åpningsgebyr, kontoadministrasjonsgebyr, stop-loss gebyr, depositumgebyr, lagrings/leveringsgebyr er alle gratis.",
    "index05": "Sikker og pålitelig sikkerhet",
    "index06": "Ved hjelp av GMG INTs ekspertise siden oppstart, bygger vi et robust system og implementerer ulike sikkerhetstiltak for å trygt beskytte kundenes eiendeler.",
    "index07": "Fysisk handel og giring er tilgjengelig",
    "index08": "Små handler kan gjøres fra rundt 10 dollar, og spreaden er den smaleste i bransjen, giring kan gjøres med kontoens saldo som sikkerhet, kun GMG INT kan ta giringsgebyrer.",
    "index09": "Token designet for å styrke GMG INT-fellesskapets evner",
    "index10": "Unus Sed LEO er et applikasjons-token, designet for å hjelpe brukere som søker å maksimere fordelene og funksjonene ved GMG INT handelsplattform.",
    "index11": "Token designet for å styrke GMG INT-fellesskapets evner",
    "index12": "Åpne veien til et bedre liv",
    "index13": "Alle kan ha kryptovaluta. Alle kan handle kryptovaluta. Her er hvordan Bitget tar deg et skritt videre.",
    "index14": "Innovative produkter",
    "index15": "Én-klikks kopi handel",
    "index16": "Handel uten å konvertere tokens",
    "index17": "Støtter hovedderivatbørser med USDC margin",
    "index18": "Risiko kontrollert ved hjelp av kalde og varme lommebøker",
    "index19": "12 A+ vurdering fra SSL-laboratoriet",
    "index20": "Pålitelige sikkerhetsløsninger støttet av Suntwin-teknologi, Qingsong Cloud Security, HEAP og Armors",
    "index21": "Fremragende kundeservice",
    "index22": "Døgnåpen flerspråklig online støtte",
    "index23": "En-til-en støtte for VIP-kunder",
    "index24": "Belønningssenter for fellesskapet",
    "index25": "Bygget av tradere for tradere",
    "index26": "Handle ulike digitale eiendeler som Bitcoin, Ethereum, Solana og Dogecoin til lave handelskostnader",
    "index27": "Verktøyene og informasjonen du trenger for å kjøpe, selge, handle, investere og bruke kryptovaluta",
    "index28": "Bransjens ledende sikkerhet"
  },
  "langNew": {
    "gdjy": "Limit ordre handel",
    "szhb": "Digitale valutaer",
    "gjs": "Edelmetaller",
    "yy": "Råolje",
    "jy": "Handel",
    "jmhb": "Kryptovaluta",
    "yxhy": "Evig kontrakt",
    "khh": "Bank",
    "qsrkhh": "Vennligst skriv inn bank",
    "yhkh": "Bankkontonummer",
    "qsryhkh": "Vennligst skriv inn bankkontonummer",
    "mnzh": "Simuleringskonto",
    "cjmnzhcg": "Simuleringskonto opprettet",
    "tcmnzh": "Logg ut av simuleringskonto"
  }
}



// WEBPACK FOOTER //
// ./src/lang/no.js